import React from 'react';
import type { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import { useChangelog } from '../../hooks/changelog';

export const ChangelogContent: FC = () => {
  const changelog = useChangelog();

  return (
    <ReactMarkdown disallowedElements={['a']} unwrapDisallowed>
      {changelog}
    </ReactMarkdown>
  );
};
